import { useParams } from 'react-router-dom';

import { PricingModel } from '../../../../../../../backend/src/types/types';
import useGetOrganisation from '@/api/queries/useGetOrganisation';
import { useGlobalAdminCheck } from '@/hooks/useGlobalAdminCheck';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { UsersTable } from '@/new/components/users-table';

export function AdminManageUsers() {
  const { organisationId } = useParams();
  if (!organisationId) return null;

  useGlobalAdminCheck();

  const { data: organisation } = useGetOrganisation(organisationId);

  return (
    <>
      <Breadcrumb
        items={
          organisation
            ? [
                { href: '/admin/organisations', label: 'Admin', active: false },
                {
                  href: `/admin/organisations/${organisation.id}`,
                  label: organisation.name,
                  active: false,
                },
                {
                  href: `/admin/organisations/${organisation.id}/users`,
                  label: 'Users',
                  active: true,
                },
              ]
            : [{ href: '/admin/organisations', label: 'Admin', active: false }]
        }
      />

      <PageContainer>
        <PageHeader>
          <PageTitle text="Manage Users" />
        </PageHeader>
      </PageContainer>

      <UsersTable organisationId={organisationId} isSeatBased={organisation?.pricingModel === PricingModel.SeatBased} />
    </>
  );
}
